import React from 'react';
import { useSearchBarContext } from '../../Context/SearchBarContext';
import { ESearchBarStatus } from '../../Context/types';
import { SearchResults } from './SearchResults';
import { RecentSearches } from './RecentSearches';
import { FmlxProgressBar } from 'fmlx-common-ui';

const SearchBarLoadingSpinner = () => (
  <div
    id="search-result-panel-loading-spinner"
    className="flex w-full justify-center items-center my-2"
  >
    <FmlxProgressBar
      type={FmlxProgressBar.Type.CIRCULAR}
      variant={FmlxProgressBar.Variant.INDETERMINATE}
      size={FmlxProgressBar.Size.SMALL}
    />
  </div>
);

const NotFoundText = () => (
  <div
    id="search-result-panel-not-found"
    className="font-[Roboto] text-[#888888] text-center"
  >
    Not Found
  </div>
);

const getSearchStatusView = (status: ESearchBarStatus, onSearch: () => void) => {
  switch (status) {
    case ESearchBarStatus.Empty:
      return <RecentSearches />;
    case ESearchBarStatus.Loading:
      return <SearchBarLoadingSpinner />;
    case ESearchBarStatus.Finished:
      return <SearchResults onSearch={onSearch} />;
    case ESearchBarStatus.NoResults:
      return <NotFoundText />;
    default: {
      const _exhaustiveCheck: never = status;
      return _exhaustiveCheck;
    }
  }
};

interface SearchResultPanelProps {
  onSearch: () => void;
}

export const SearchResultPanel = ({ onSearch }: SearchResultPanelProps) => {
  const { status } = useSearchBarContext();
  return (
    <div
      id="search-result-panel-wrapper"
      className="w-full h-full flex-1 bg-white rounded-sm"
    >
      <div id="search-result-panel-content" className="m-2">
        {getSearchStatusView(status, onSearch)}
      </div>
    </div>
  );
};
